import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

const getBasePath = () => {
    const path = window.location.pathname;
    return path
        .replace(/\/detail\/?$/, '')
        .replace(/\/list\/?$/, '')
        .replace(/\/form\/?$/, '')
        .replace(/\/$/, '');
};

const NavBar = ({ className }) => {
    const origin = window.location.origin;
    const path = window.location.pathname;
    const base = getBasePath();

    const items = [
        {
            key: 'home',
            label: '首页',
            href: `${origin}${base}/list`,
        }
    ];

    return (
        <nav className={`${styles.nav} ${className || ''}`.trim()} aria-label="页面导航">
            <ul className={styles.navList}>
                {items.map((item) => {
                    const commonClass = `${styles.navItem}`.trim();

                    return (
                        <li key={item.key} className={commonClass}>
                            <a href={item.href} className={styles.navLink}>
                                {item.label}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
};

NavBar.propTypes = {
    className: PropTypes.string,
};

export default NavBar;

